export const domain = 'ActivitiesModel'

export const onCreateActivityData = `${domain}/onCreateActivityData`
export const onBatchActivtiesData = `${domain}/onBatchActivtiesData`
export const onBatchActivitiesChangedProps = `${domain}/onBatchActivitiesChangedProps`